import { useCallback, useEffect, useState } from 'react';
import { applyTheme, getStoredTheme, type Theme } from '@/lib/theme';

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => getStoredTheme());
  useEffect(() => { applyTheme(theme); }, [theme]);
  const setTheme = useCallback((value: Theme) => setThemeState(value), []);
  const toggle = useCallback(() => setThemeState((current) => current === 'dark' ? 'light' : 'dark'), []);
  return { theme, setTheme, toggle };
}
